<template>
  <el-dialog title="开户进度"
             :visible.sync="dialogVisible"
             width="768px"
             :before-close="handleClose">
    <div class="main">
      <!--       {{applyinfor}} -->
      <el-row :gutter="20">
        <el-col :span="4">
          开户进度:
        </el-col>
        <el-col :span="20" v-if="applyinfor">
          {{applyinfor.applyment_state=='CHECKING'?'资料校验中':applyinfor.applyment_state=='ACCOUNT_NEED_VERIFY'?'待账户验证':applyinfor.applyment_state=='AUDITING'?'审核中':applyinfor.applyment_state=='REJECTED'?'已驳回':applyinfor.applyment_state=='NEED_SIGN'?'待签约':applyinfor.applyment_state=='FINISH'?'完成':'已冻结'}}
        </el-col>      
      </el-row>
      <el-row :gutter="20" v-if="applyinfor.legal_validation_url">
        <el-col :span="4">
          法人代表签约:
        </el-col>
        <el-col :span="20" v-if="applyinfor.legal_validation_url">
          {{applyinfor.legal_validation_url}}
        </el-col>      
      </el-row>
      <el-row :gutter="20" v-if="applyinfor.sign_url">
        <el-col :span="4">
          超级管理员签约:
        </el-col>
        <el-col :span="20" v-if="applyinfor.sign_url">
          {{applyinfor.sign_url}}
        </el-col>      
      </el-row>
        <el-row :gutter="20" v-if="applyinfor.legal_validation_url ||applyinfor.sign_url">
        <el-col :span="20" style="color:red">
          请在微信客户端打开链接
        </el-col>
          
      </el-row>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {
      dialogVisible: false,
      applyinfor: null

    };
  },
  updated () {
    console.log(this.applyinfor, 'applyinfor')
  },
  methods: {
    handleClose () {
      this.dialogVisible = false;
    },

  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.main {
  max-height: 500px;
  width: 100%;
  padding-bottom: 30px;
  ::v-deep .el-row{
   padding: 20px 0;
  }
}
</style>
